import { TimePicker, TimePickerProps, TimeField } from 'app2/components';

import { withSiteOrCompanyTimezone } from './withSiteOrCompanyTimezone';
import { SiteOrCompanyDateText } from './SiteOrCompanyDateField'

export const SiteOrCompanyTimePicker = withSiteOrCompanyTimezone<TimePickerProps>(TimePicker);

export const SiteOrCompanyTimeField = {...TimeField, display: {...TimeField.display, component: SiteOrCompanyDateText}, edit: {...TimeField.edit, component:SiteOrCompanyTimePicker}};
